import { useMemo } from 'react'

const useTransformAxisBottom = (height: number): string =>
  useMemo((): string => `translate(0, ${height})`, [height])

export default useTransformAxisBottom
